import axios from 'axios';
import {
	FETCH_POSTBOXES_FAILED,
	FETCH_POSTBOXES_FULFILLED,
	FETCH_POSTBOXES_PENDING,
} from '../constants/actions/postboxesActions';
import { POSTBOXES } from '../constants/paths/api';

export const fetchPostboxesPending = () => ({
	type: FETCH_POSTBOXES_PENDING,
	payload: null,
});

export const fetchPostboxesFulfilled = postOffices => ({
	type: FETCH_POSTBOXES_FULFILLED,
	payload: {
		postOffices,
	},
});

export const fetchPostboxesFailed = error => ({
	type: FETCH_POSTBOXES_FAILED,
	payload: {
		error,
	},
});

export const fetchPostboxes = () => {
	return async dispatch => {
		dispatch(fetchPostboxesPending());

		try {
			const response = await axios(`${POSTBOXES}`);
			dispatch(fetchPostboxesFulfilled(response.data));
		} catch (error) {
			dispatch(fetchPostboxesFailed(error));
		}
	};
};
